module.exports = __webpack_public_path__ + "img/img_hula_phone_banner.33fbb192.png";